/**
 * 拼接ws链接
 * @param tpl
 * @param params
 * @returns
 */
const generateWssUrl = (tpl: string, params: Record<string, string>) => {
  const url = Object.keys(params).reduce((res, curr: string) => res.replace(`{{${curr}}}`, `${params[curr]}`), tpl)
  return encodeURI(url)
}

export default generateWssUrl
